const colors = {
  dark: {
    foreground: {
      action: '#1f78d1',
    },
    ornament: {
      border: '#1f1f1f',
    },
    background: {
      primary: '#000000',
      secondary: '#0a0a0a',
    },
  },
};

export default colors;
